import '../../StyleSheets/StyleSheetPages.css';
import { Box, Typography } from '@mui/material';

function SchoolFee() {
  return (
    <div className="school-fee-container">
        <h2 className="stylesheetpage-title">School Fees</h2>





<div style={{ textAlign: 'justify' }}>
  {/* Description Box */}
  <div style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '20px', borderRadius: '8px' }}>
    <p>
      The homelike quality of our school contributes to a relaxed, focused experience for the child. Our indoor
      classroom activities are placed on open shelves for selection as interest and readiness inspires the child.
      Our outdoor environment offers a beautiful developed playground with manipulatives, tricycles, pets, and gardens.
    </p>
  </div>

  {/* School Fee Box */}
  <div style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '20px', borderRadius: '8px' }}>
    <h4>School Fee</h4>
    <table>
      <tbody>
        <tr>
          <td>Early Years (Play Group)</td>
          <td>$1,600/- Annually</td>
        </tr>
        <tr>
          <td>FS 1</td>
          <td>$2,000/- Annually</td>
        </tr>
        <tr>
          <td>FS 2 & Year 1</td>
          <td>$2,400/- Annually</td>
        </tr>
        <tr>
          <td>Year 2, 3, 4</td>
          <td>$2,800/- Annually</td>
        </tr>
        <tr>
          <td>Year 5, 6</td>
          <td>$3,200/- Annually</td>
        </tr>
        <tr>
          <td>Pre-IGCSE I, II, III</td>
          <td>$4,000/- Annually</td>
        </tr>
        <tr>
          <td>IGCSE I, II</td>
          <td>$4,800/- Annually</td>
        </tr>
        <tr>
          <td>AS-Level & A-Levels (Grades 11,12)</td>
          <td>$5,600/- Annually</td>
        </tr>
        <tr>
          <td>Annual one time charges IGSE (Grade 9,10) and A-Levels (Grade 11,12)</td>
          <td>$40/- Annually</td>
        </tr>
        <tr>
          <td>Clubs & Activities (Complimentary for this year)</td>
          <td>$160/- Annually</td>
        </tr>
        <tr>
          <td>Security Fee (Refundable)</td>
          <td>$480</td>
        </tr>
        <tr>
          <td>Admission Fee (Non-Refundable)</td>
          <td>$400</td>
        </tr>
      </tbody>
    </table>
    <p><strong>Dollar Conversion Rate = 220 <br />
      *Please note: The conversion rate is subject to change at any time
    </strong></p>
  </div>

  {/* Tuition Fee Discount Box */}
  <div style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '20px', borderRadius: '8px' }}>
    <p><strong>Tuition Fee Discount</strong></p>
    <table style={{ width: '70%' }}>
      <tbody>
        <tr>
          <td rowSpan={3}>Special Discount for families with more than one child</td>
          <td>5% for the 2nd child</td>
        </tr>
        <tr><td>10% for the 3rd child</td></tr>
        <tr><td>10% for the 4th child</td></tr>
      </tbody>
    </table>
  </div>

  {/* Transport Fee Box */}
  <div style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '20px', borderRadius: '8px' }}>
    <p><strong>Transport Fee (Zone Wise)</strong></p>
    <table style={{ width: '70%' }}>
      <tbody>
        <tr>
          <td rowSpan={5}>
            Note: Transport fee is subject to change according to fuel price. Withholding tax will be
            collected as per government policy
          </td>
          <td>Zone 1</td>
          <td>8,000 Rs. Monthly</td>
        </tr>
        <tr><td>Zone 2</td><td>10,000 Rs. Monthly</td></tr>
        <tr><td>Zone 3</td><td>12,000 Rs. Monthly</td></tr>
        <tr><td>Zone 4</td><td>13,000 Rs. Monthly</td></tr>
        <tr><td>Zone 5</td><td>16,000 Rs. Monthly</td></tr>
      </tbody>
    </table>

    <br />

    <table style={{ width: '70%' }}>
      <tbody>
        <tr><td>Zone 1</td><td>Bahria Town Phase I-II, Media Town, Safari Villas 1, Gulraiz 2 & 3</td></tr>
        <tr><td>Zone 2</td><td>Bahria Town Phase III-VI</td></tr>
        <tr>
          <td>Zone 3</td>
          <td>
            Bahria Town Phase VII-VIII, DHA I & II, Model Town, Humak, Scheem III, Gulistan Colony,
            Police Foundation, PWD, Pakistan Town, Soan Garden, Korang Town
          </td>
        </tr>
        <tr><td>Zone 4</td><td>Judicial Colony up to Faizabad, Janda Chichi to Murree Road, Chungi # 22 & Adiala Road</td></tr>
        <tr><td>Zone 5</td><td>Islamabad City</td></tr>
      </tbody>
    </table>
  </div>

  {/* Policies Box */}
  <div style={{ border: '1px solid #ccc', padding: '15px', marginBottom: '20px', borderRadius: '8px' }}>
    <ol>
      <li>
        First Challan Form will be issued upon submission of complete Admission Form along with necessary documents and clearing of Admission Test.
      </li>
      <li>
        Security Fee is payable at the time of admission and is refundable at the time of withdrawal within a period of one month; after one month claim to Security Fee refund will not be entertained.
      </li>
      <li>
        Academy Fees are payable in 9 installments on or before the 7th day of each working calendar month.
      </li>
      <li>
        Fee once paid will be refunded only after deduction of 30% amount by the time of leaving the Academy.
      </li>
      <li>
        Fee Challans are issued latest by 25th of each month prior to billing month and sent home through students. It is the responsibility of the parents/guardians to inquire from the School’s office if they have not received the challan. Fine of $20 will be charged after due date.
      </li>
      <li>
        After the expiry of the “VALIDITY DATE” the Fee Bill will not be accepted at the local branch of bank. The new Fee Bill will only be issued with an additional fine of $05 per Fee Bill plus late payment charges incurred till date.
      </li>
      <li>
        Students whose fees remain payable after expiry of DUE/VALIDITY DATE for 1 month are issued periodic reminders and ultimately the ‘Final’ reminder; thereafter which the student’s name will be struck off the school roll (Compulsory Withdrawal) and outstanding dues adjusted against security deposit and re-admission charges (Admission Fee) shall be levied.
      </li>
      <li>
        The ACE International Academy reserves rights to hold student’s progress reports/transcripts, Examination Entries, school leaving and other certificates if the dues have not been cleared.
      </li>
      <li>
      All dues are paid directly to the ACE International Academy designated Bank Accounts Department except for foreign currency cash which must be paid at Academy Accounts Department.
      </li>
      <li>
      There will be no concession or fee waiver for the period that a child may have stayed away from school due to illness, social commitments, visit abroad or for any other reason. No freezing policy applies.
      </li>

    </ol>
  </div>
</div>









        
       




    </div>
  );
}

export default SchoolFee;




















// import Accordion from 'react-bootstrap/Accordion';
// import Table from 'react-bootstrap/Table';

// function BasicExample() {
//   return (
//     <div style={{ width: "80%", margin: "0 auto" }}>
//       <Accordion defaultActiveKey="0">
//         <Accordion.Item eventKey="0">
//           <Accordion.Header>Admissions</Accordion.Header>
//           <Accordion.Body>
//             The homelike quality of our school contributes to a relaxed, focused experience for the child. Our indoor classroom activities are placed on open shelves for selection as interest and readiness inspires the child. Our outdoor environment offers a beautiful developed playground with manipulatives, tricycles, pets, and gardens.
//           </Accordion.Body>
//         </Accordion.Item>

//         <Accordion.Item eventKey="1">
//           <Accordion.Header>Fee Schedule</Accordion.Header>
//           <Accordion.Body>
//             <Table striped bordered hover>
//               <tbody>
//                 <tr><td>Early Years (Play Group)</td><td>$1,600/- Annually</td></tr>
//                 <tr><td>FS 1</td><td>$2,000/- Annually</td></tr>
//                 <tr><td>FS 2 & Year 1</td><td>$2,400/- Annually</td></tr>
//                 <tr><td>Year 2,3,4</td><td>$2,800/- Annually</td></tr>
//                 <tr><td>Year 5,6</td><td>$3,200/- Annually</td></tr>
//                 <tr><td>Pre-IGCSE I,II,III</td><td>$4,000/- Annually</td></tr>
//                 <tr><td>IGCSE I,II</td><td>$4,800/- Annually</td></tr>
//                 <tr><td>AS-Level & A-Levels (Grades 11,12)</td><td>$5,600/- Annually</td></tr>
//                 <tr><td>Annual one-time charges (IGCSE, A-Levels)</td><td>$40/- Annually</td></tr>
//                 <tr><td>Clubs & Activities (Complimentary)</td><td>$160/- Annually</td></tr>
//                 <tr><td>Security Fee (Refundable)</td><td>$480</td></tr>
//                 <tr><td>Admission Fee (Non-Refundable)</td><td>$400</td></tr>
//               </tbody>
//             </Table>
//           </Accordion.Body>
//         </Accordion.Item>
//       </Accordion>
//     </div>
//   );
// }

// export default BasicExample;
